module.exports = __webpack_public_path__ + "static/media/ic-face-orange-original.60926a8b.svg";